import { atomWithStorage } from 'jotai/utils';
import { USER_KEY } from '../lib/constants';
import { UserModel } from 'src/types/user';

export const userAtom = atomWithStorage<UserModel | null>(USER_KEY, null);
